<template>
  <v-card>

    <v-card-title class="headline green lighten-2">
      Extension Edit
    </v-card-title>

    <v-card-text>
      <v-form v-model="valid_form">
        <v-container grid-list-lg>
          <v-layout wrap>
            <v-flex xs12 md5>
              <v-text-field v-model="extdata.name" label="Extension Number" :readonly="!isNewRecord" :disabled="busy" :rules="ext_number_rules" :prefix="branch_code"></v-text-field>
            </v-flex>
            <v-flex xs12 md7>
              <v-text-field v-model="extdata.password" label="Password" :type="hide_password ? 'password' : 'text'" :append-icon="hide_password ? 'visibility' : 'visibility_off'" @click:append="hide_password = !hide_password" :disabled="busy" :rules="password_rules"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field v-model="extdata.description" label="Description" :disabled="busy"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12>
              <v-combobox v-model="callgroups" label="Call Groups" multiple small-chips clearable deletable-chips @input="groupsInput('callgroups')" :disabled="busy" :items="group_tags"></v-combobox>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12>
              <v-combobox v-model="pickupgroups" label="Pickup Groups" multiple small-chips clearable deletable-chips @input="groupsInput('pickupgroups')" :disabled="busy" :items="group_tags"></v-combobox>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12>
              <v-checkbox v-model="extdata.usetls" label="Use TLS transport" :disabled="busy"></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" flat @click="cancelForm" :disabled="busy">
        Cancel
      </v-btn>
      <v-btn color="primary" flat @click="submitForm" :loading="busy">
        OK
      </v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>
export default {
  name: 'extenedit',
  props: {
    item: {
      required: true,
      type: Object
    },
    busy: {
      required: true,
      type: Boolean
    },
    group_tags: {
      required: true,
      type: Array
    }
  },
  data: () => ({
    valid_form: false,
    extdata: {},
    callgroups: [],
    pickupgroups: [],
    hide_password: true,
    ext_number_rules: [
      v => ((v != null) && (v.length > 0)) || 'Extension must be provided',
      v => ((v != null) && (v.match(/^[0-9]+$/) != null)) || 'Only numeric characters allowed'
    ],
    password_rules: [
      v => (v && v.length > 5) || 'Should be at least 6 characters'
    ]
  }),
  watch: {
    item: function () {
      let new_data = {}
      Object.keys(this.item).forEach(function(fld) {
        if (fld === 'name') {
          var re = new RegExp('^' + this.branch_code)
          new_data['name'] = this.item['name'].replace(re,'')
          return
        }
        new_data[fld] = this.item[fld]
      },this)
      this.extdata = Object.assign({},new_data)

      this.callgroups = 'callgroups' in this.item ? this.item['callgroups'].slice() : []
      this.pickupgroups = 'pickupgroups' in this.item ? this.item['pickupgroups'].slice() : []
    }
  },
  computed: {
    isNewRecord: function () {
      return !this.extdata.hasOwnProperty('id')
    },
    branch_code: function () {
      return this.$store.getters.auth_branch_code
    }
  },
  methods: {
    groupsInput: function (gr) {
      var obj = null
      if (gr === 'callgroups') {
        obj = this.callgroups
      }
      if (gr === 'pickupgroups') {
        obj = this.pickupgroups
      }
      if (!obj) {
        return ''
      }

      let lca = obj.map(function (s) {
        return s.toLowerCase()
      })

      let uniq = {}
      for (let v of lca) {
        uniq[v] = true
      }

      obj.length = 0
      Object.keys(uniq).forEach(function(k) { obj.push(k) })
    },
    submitForm: function () {
      //this.extdata.callgroups = Object.assign({},this.callgroups)
      this.extdata.callgroups = []
      Object.keys(this.callgroups).forEach(function(idx) {
        this.extdata.callgroups.push(this.callgroups[idx])
      },this)
      this.extdata.pickupgroups = []
      Object.keys(this.pickupgroups).forEach(function(idx) {
        this.extdata.pickupgroups.push(this.pickupgroups[idx])
      },this)
      this.$emit('submit',{ new_record: this.isNewRecord, data: this.extdata })
    },
    cancelForm: function () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
</style>
